import { ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * Compact privacy reassurance notice shown beside a Submit/Publish action —
 * not a full policy section, just a short trust note + link to the real
 * Privacy Policy page.
 */
export function PrivacyReassuranceNote({ heading, children, testId }) {
  return (
    <div
      className="flex items-start gap-2.5 rounded-xl border border-slate-200 bg-slate-50 p-3.5 text-xs text-ink-muted"
      data-testid={testId}
    >
      <ShieldCheck className="w-4 h-4 text-teal shrink-0 mt-0.5" strokeWidth={1.75} />
      <p>
        <span className="font-semibold text-ink">{heading} </span>
        {children}{" "}
        <Link to="/privacy-policy" className="text-teal hover:underline font-medium whitespace-nowrap">
          Read our Privacy Policy
        </Link>
      </p>
    </div>
  );
}
